import { render, staticRenderFns } from "./inoutTaskItem.vue?vue&type=template&id=2a8148b2&scoped=true&"
import script from "./inoutTaskItem.vue?vue&type=script&lang=js&"
export * from "./inoutTaskItem.vue?vue&type=script&lang=js&"
import style0 from "./inoutTaskItem.vue?vue&type=style&index=0&id=2a8148b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8148b2",
  null
  
)

export default component.exports